export default "__VITE_ASSET__a4f07d43__"